import React from 'react'
import ContentBodyshopForm from '../../../components/ContentBodyshopForm'
import { Flex } from 'rebass'
import styled from 'styled-components'

const FlexWrapper = styled(Flex)`
  position: relative;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  overflow: hidden;
`

const BodyshopForm = () => (
  <FlexWrapper flexWrap="wrap">
    <ContentBodyshopForm />
  </FlexWrapper>
)

export default BodyshopForm
